import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {eq} from 'lodash/lang'
import styles from './b2bCompanyPolicyHistory.scss'
import NoResults from '../noResults'
import TooManyResults from '../tooManyResults'
import underscore from 'underscore'
import moment from 'moment'
import RefreshBtn from './../refreshBtn'

import i18n from 'lib/i18n'
const _ = i18n('b2bCompany')

export default	class B2bCompanyPolicyHistory extends React.Component {
	static propTypes = {
		data: PropTypes.array,
		actionNames: PropTypes.object,
		categoryNames: PropTypes.object,
		statusNames: PropTypes.object,
        handlePerformRecuperation: PropTypes.func.isRequired,
		getHistory: PropTypes.func.isRequired,
		getContracts: PropTypes.func.isRequired,
	}

	constructor(props) {
		super(props)
		this.refreshRecuperationColumnVisibility()
    }
    /**
     * We should display recuperation column only if a recuperation code exists and will be button for it
     */
    refreshRecuperationColumnVisibility() {
        this.showRecuperation = false
        this.props.data && this.props.data.forEach((historyline) => {
            this.showRecuperation = (
                (historyline.recuperation === "true" || historyline.recuperation === true) && true
            ) || this.showRecuperation
        });
    }

	shouldComponentUpdate(nextProps) {
		return !eq(this.props.data, nextProps.data)
	}
	parseClientNumber (clientString) {
		const clientData = !underscore.isEmpty( clientString ) && clientString.split(":") || []
		const clientNumber = !underscore.isEmpty( clientData ) && !underscore.isEmpty( clientData[0] ) &&
			clientData[0] || "-"
		return clientNumber.trim()
	}
	parseClientName (clientString) {
		const clientData = !underscore.isEmpty( clientString ) && clientString.split(":") || []
		const clientName = !underscore.isEmpty( clientData ) && !underscore.isEmpty( clientData[1] ) &&
			clientData[1] || "-"
		return clientName.trim()
    }
    refresh(force) {
		const {getHistory, getContracts} = this.props
        getHistory(force).then(
            (res) => this.refreshRecuperationColumnVisibility()
        ).then(() => {
            this.forceUpdate()
            getContracts()
        })
	}

	render() {
        const {data, actionNames, categoryNames, statusNames, handlePerformRecuperation,
            getHistory} = this.props
		{/*const recuperationNames = {
			"true": _('recupered'),
			"false": _('notRecupered'),
		}*/}

        const tableColumns = [
            "transactionDate",
            "action",
            "category",
            "status",
            "clientNumber",
            "clientName",
            "brokerNumber",
            "transactionId",
            "contractNumber"
        ]

        const tableColumnsSort = [
            {
                column: "transactionDate",
                sortFunction: (aDate, bDate) => {
                    var mDateA = moment(aDate, "DD-MM-YYYY HH:mm")
                    var mDateB = moment(bDate, "DD-MM-YYYY HH:mm")
                    return ((mDateA < mDateB) ? -1 : ( (mDateA > mDateB ? 1 : 0 )))
                }
            },
            "action",
            "category",
            "status",
            "clientNumber",
            "clientName",
            "brokerNumber",
            "transactionId",
            "contractNumber"
        ]

        this.showRecuperation && tableColumns.push("recuperation")

        let tableHeader =
            <Thead>
                {tableColumns
                    .filter((elem)=> elem !== "recuperation" || this.showRecuperation)
                    .map((elem, key) =>
                    <Th key={key} column={elem}>
                        <strong>{_(elem)}</strong>
                    </Th>
                )}
            </Thead>

		return (
			<div>
				<h3>{_('b2bCompanyPolicyActionsHistory')}</h3>
				<div className={styles.moduleSection}>
					<div className={styles.clientsTableContainer}>
						{ data && underscore.isArray(data) && (data[0] !== 'Too many rows') &&
							<Table
								className={styles.table}
								itemsPerPage={10}
								filterable={tableColumns}
								sortable={tableColumnsSort}
								defaultSort={{
									column: 'transactionDate',
									direction: 'desc',
                                }}
                                topPaginationElemL={
                                    [
                                        <RefreshBtn
                                            key="r"
                                            onClick={() => {
                                                this.refresh(true)
                                            }}
                                        />,
                                    ]
                                }
							>
								{ tableHeader }
								{ data.map((item, key) => {
									return (
									<Tr className="centered" key={key}>
										<Td column="transactionDate">{item.transactionDate}</Td>
										<Td column="action">{actionNames[item.action] || item.action}</Td>
										<Td column="category">{categoryNames[item.category] || item.category}</Td>
										<Td column="status">{statusNames[item.status] || item.status}</Td>
										<Td column="clientNumber">{this.parseClientNumber(item.client)}</Td>
										<Td column="clientName">{this.parseClientName(item.client)}</Td>
										{/*<Td column="company">{item.company}</Td>*/}
										<Td column="brokerNumber">{item.brokerNumber}</Td>
										<Td column="transactionId">{item.transactionId}</Td>
										<Td column="contractNumber">{item.contractNumber}</Td>
										{this.showRecuperation && <Td column="recuperation">
											{item.recuperation === "true" &&
												<button
													disabled={!item.recupCode}
													className={styles.greyButton}
													onClick={(e) => handlePerformRecuperation(item)}
													type="button"
												>
													{_('performRecuperation')}
												</button>
												|| null
											}
										</Td>}
										{/*<Td column="recupCode">{item.recupCode}</Td>*/}
									</Tr> )}
									)
								}
							</Table>
						}
						{ data && underscore.isArray(data) && data.length === 0 &&
						<NoResults type="b2bCompanyPolicyActionsHistory"/>
						}
						{ data && underscore.isArray(data) && data[0] === 'Too many rows' &&
						<TooManyResults	type="b2bCompanyPolicyActionsHistory"/>
					}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanyPolicyHistory.jsx